import { useEffect } from 'react'
import { useFormModal } from '@/Ship/Hooks/useFormModal'

export const useCancelRequestModal = ({ crudContext }: any) => {
    const { Modal, localStorage: cancelModal } = useFormModal({
        fields: {
            cancellationReason: {
                label: 'Причина скасування',
                type: 'select',
                resource: 'Setting.ListCancellationReason',
                isRequired: true,
                inputProps: { filter: { isActive: true } },
            },
        },
        modalProps: {
            title: 'Скасувати заявку',
            okText: 'Скасувати заявку',
            okButtonProps: { danger: true },
        },
        restUri: '/services/transport-requests/__uuid__/cancel',
        restUriReplaceParams: (uri: string) =>
            uri.replace('__uuid__', crudContext?.formContext?.values?.uuid),
        requestSuccessMessage: 'Заявку скасовано',
        onAfterSuccessRequest: () => crudContext?.actions?.reloadData?.(),
    })

    useEffect(() => {
        const em = crudContext?.eventManager
        if (!em) return

        em.on('requestAction:openCancelModal', 'cancelModalHandler', () => {
            cancelModal.setIsModalOpen(true)
        })

        return () => em.off('requestAction:openCancelModal', 'cancelModalHandler')
    }, [crudContext, cancelModal])

    return { Modal }
}
